const action = 'ORGANIZATIONS_SSO_UPDATE';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { orgId, body }
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

// payload: unwrapped PUT response ({ sso, redirect_uri })
export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
